// The Inputs rows of a Sub-workflow. The model stores them as key to template; a key with no value is not stored.

/**
 * The keys to show a row for: the ones the called workflow reads, then any that are stored but no longer read.
 * A stored value the editor did not show would still be sent to the called workflow.
 */
export function inputKeysToShow(keysRead: string[], inputs: Record<string, string>): string[] {
  const storedButNotRead = Object.keys(inputs).filter((key) => !keysRead.includes(key))
  return [...keysRead, ...storedButNotRead]
}

/** The inputs with one key set. An emptied value removes the key. */
export function withInput(inputs: Record<string, string>, key: string, value: string): Record<string, string> {
  const next = { ...inputs }
  if (value === '') delete next[key]
  else next[key] = value
  return next
}
